module.exports = __webpack_public_path__ + "img/banner2.041db518.png";